import {
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
  ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
  ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2,
} from '../constants/routePathConstants';
import { Link, useSearchParams } from 'react-router-dom';
import { MODEL_TYPES } from '../constants/constants';
import ThumbnailCardV2 from './ThumbnailCardV2';
import { getCuratorRoomPath } from '../helpers/urlHelper';
import { useTemplateActions } from '../hooks/useTemplateActions';
import { PRODUCT_PAGE_SHARE_ACCESS } from '../screens/NewProductUIV2/ShareProductPageModal';

export const ThumbnailCardSharedProductPage = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  to = null,
  hideFavourite,
  onEdit,
  onEditInfo,
  modelType = MODEL_TYPES.SHARED_PRODUCT_PAGE,
  curatorProp,
  designV2,
  showMenu,
  redirect,
  ...rest
}) => {
  const [params] = useSearchParams();
  const {
    onEditInfo: _onEditInfo,
  } = useTemplateActions({
    item: data,
  });

  const isViewAccess = +data?.permission_type === PRODUCT_PAGE_SHARE_ACCESS.CAN_VIEW

  const cameraName = data?.images?.[0]?.cameraName;
  const url = getCuratorRoomPath(data.id, {
    cameraName: cameraName,
    propId: curatorProp,
  });
  const thumbnail =  data?.thumbnail || data?.product_thumbnail || data?.texture_thumbnail;

  to = to + `?${params}`;

  const titleProps = !redirect ? null: {
    as: Link,
    target: '_blank',
    to: url,
    onClick: (e) => {
      handleOpenPublicOrProduct()
      e.preventDefault();
      return;
    },
  };

  const handleOpenPublicOrProduct = () => {
    const isProductPage = data?.product;
    const isTexturePage = data?.texture;
    const unicode = data?.unicode;
  
    const baseUrls = {
      texture: isViewAccess
        ? ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2
        : ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
      product: isViewAccess
        ? ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC_V2
        : ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
    };
  
    const selectedPage = isTexturePage ? "texture" : "product";
    const identifier = isViewAccess ? unicode : isTexturePage ? isTexturePage : isProductPage;
  
    const url = `${baseUrls[selectedPage].replace(":id", "")}${identifier}`;
    window.open(url, '_blank');
    return url
  };
  

  return <ThumbnailCardV2
      // onFavouriteChange={onFavouriteToggle(data)}
      // onSelect={onSelect}
      // selected={selected}
      // isFavourite={data.is_favourite}
      hideFavourite={true}
      // favouriteLoading={favouriteLoading}
      titleProps={titleProps}
      data={data}
      id={data?.id}
      name={data?.name}
      thumbnail={thumbnail}
      // images={updatedImages}
      date={
        data?.created_at
      }
      userCard
      showMenu={showMenu}
      showCheckbox={false}
      onCardClick={()=> handleOpenPublicOrProduct()}
      // isFavouriteIcon
      // onEdit={handleEdit}
      // savePreviousRoute
      // onEditInfo={isEditor ? handleEditInfo : null}
      // redirectURL={`${isViewAccess ? TEMPLATES_ROUTE_V2 : ADMIN_MY_PRODUCTS_ROOMS_V2}/${data?.id}`}
      // redirectTarget="_self"
      {...rest}
    />
};
